// extracted by mini-css-extract-plugin
module.exports = {"check":"styles_check__4V4J2"};